export const DAILY_FEATURES_CONFIG = [
  {
    id: "word",
    name: "FinWord Puzzle",
    description: "Crack the daily 5-letter finance word in 6 attempts.",
    path: "/daily/word",
    icon: "Type",
  },
  {
    id: "quiz",
    name: "Finance Quiz",
    description: "Test your financial knowledge with 4 quick questions.",
    path: "/daily/quiz",
    icon: "Brain",
  },
];
